import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { Locale } from "@/i18n";
import { localePath } from "@/lib/nav";
const contemporaryImg = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-07-1000x1000.webp";
const classicImg = "https://media.lacontessina.com/site/src/assets/products/remote/foto-2-800x800.webp";
const textileImg = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-5.jpg";
export default function CategoriesBanner() {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language as Locale) || "it";

  const items = [
    {
      href: localePath(locale, "products", "classic"),
      title: t("style.classic"),
      img: classicImg,
      caption: "01",
    },
    {
      href: localePath(locale, "products", "contemporary"),
      title: t("style.contemporary"),
      img: contemporaryImg,
      caption: "02",
    },
    {
      href: localePath(locale, "products", "textile"),
      title: t("style.textile"),
      img: textileImg,
      caption: "03",
    },
  ];

  return (
    <section id="collections" className="relative w-full py-20 lg:py-28 bg-[hsl(var(--surface))]">
      <div className="lc-container-ext">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 lg:mb-16">
          <div>
            <span className="lc-eyebrow">{t("common.eyebrow.collections")}</span>
            <h2 className="mt-5 lc-section-title max-w-2xl">
              {t("categories.title_1")}
              <span className="italic font-serif font-normal"> {t("categories.title_2")}</span>
            </h2>
          </div>
          <p className="max-w-md text-foreground/60 text-[15px] leading-relaxed">
            {t("categories.description")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="group relative block overflow-hidden rounded-[24px] aspect-[3/4] bg-[hsl(var(--surface-2))]"
            >
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.06]"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent" />

              <div className="absolute top-5 left-5 text-white/80 text-[11px] tracking-[0.3em]">
                {item.caption}
              </div>

              <div className="absolute inset-x-5 bottom-5 flex items-end justify-between">
                <h3 className="font-display font-light text-white text-[28px] md:text-[36px] tracking-[-0.02em] leading-tight">
                  {item.title}
                </h3>
                <span className="h-11 w-11 rounded-full border border-white/60 flex items-center justify-center text-white transition group-hover:bg-white group-hover:text-foreground">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
